import { render } from "./MainArea.vue?vue&type=template&id=b22d77be&scoped=true&ts=true"
import script from "./MainArea.vue?vue&type=script&lang=ts"
export * from "./MainArea.vue?vue&type=script&lang=ts"

import "./MainArea.vue?vue&type=style&index=0&id=b22d77be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22d77be"]])

export default __exports__